export class VerifyMongoAtlasPrivateLinkResponse {
    'verified';
    'atlasServiceStatus';
    'atlasEndpointStatus';
    'awsVpcEndpointStatus';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "verified",
            "baseName": "verified",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "atlasServiceStatus",
            "baseName": "atlasServiceStatus",
            "type": "string",
            "format": ""
        },
        {
            "name": "atlasEndpointStatus",
            "baseName": "atlasEndpointStatus",
            "type": "string",
            "format": ""
        },
        {
            "name": "awsVpcEndpointStatus",
            "baseName": "awsVpcEndpointStatus",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return VerifyMongoAtlasPrivateLinkResponse.attributeTypeMap;
    }
    constructor() {
    }
}
